import type { LayerGroup, LayerName } from "./types";

export const LAYER_TOGGLES: readonly { group: LayerGroup; label: string; layers: LayerName[] }[] = [
  { group: "income_wealth", label: "income & wealth", layers: ["income"] },
  { group: "demographics", label: "demographics", layers: ["age", "education", "ethnicity", "language"] },
];
